import React from 'react';
import './BodyImage.css'; // make sure to create and import the CSS file for styling
import logo1 from "./logo0.png";
import logo2 from "./footer1.png";
import logo3 from "./footer2.png";
import dex from "./dexscreener.png"


function BodyImage() {
  return (
    <div className="main-container">
      <div className="body-image-container">
        <img src={logo1} alt="JECAK Token Image" className='body-image'/>
      </div>
      <div className="jecak-desc">
        <h2>Ticker: $JECAK</h2>
        <h2>Supply: 1,000,000,000</h2>
        <p>Join the Jecak revolution, where the JECAK token is reshaping the digital frontier. Beyond participants, we're pioneers forging new paths. Ready for the challenge? Be part of the journey. Explore, share, and expand the JECAK ethos online. With #JoinJecak, join forces with innovators shaping tomorrow. Let's craft the future—where we're not just dreamers, but creators. Make your mark. #JoinJecak</p>
        <div className="image-row">
        <a href="https://dexscreener.com/base/0x6652d6040ae146eeee108eb0c07b0beba3be0fc8" target="_blank" ><img src={dex} alt="Description 1" className="row-image"/></a>
        <a href="https://warpcast.com/~/channel/jacek" target="_blank" >  <img src={logo2} alt="Description 1" className="row-image"/></a>
        <a href="https://app.uniswap.org/swap?outputCurrency=0x288bd91aaf2abb51a67ec4b53b4bcd140ccfc1ee" target="_blank" >  <img src={logo3} alt="Description 2" className="row-image"/></a>
        </div>
      </div>
    </div>
  );
}

export default BodyImage;
